import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

import RevealController from '@stimulus-components/reveal'
application.register('reveal', RevealController)

import ScrollTo from '@stimulus-components/scroll-to'
application.register('scroll-to', ScrollTo)

import AutoSubmit from '@stimulus-components/auto-submit'
application.register('auto-submit', AutoSubmit)

export { application }
